import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { PefCellComponent, PefCellValueChange } from '../pef-cell/pef-cell';
import { PefCell, PefData, PefRow, PefSheet } from '../pef-schema.types';

@Component({
  selector: 'lib-pef-settings',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PefCellComponent],
  templateUrl: './pef-settings.html',
  styleUrl: './pef-settings.css',
})
export class PefSettingsComponent {
  readonly sheet = input.required<PefSheet>();
  readonly data = input.required<PefData>();
  readonly loading = input<boolean>(false);
  readonly dirtyKeys = input<ReadonlySet<string>>(new Set());
  readonly readonly = input<boolean>(false);

  readonly cellValueChange = output<PefCellValueChange>();

  protected readonly rows = computed(() => this.sheet().rows);
  protected readonly valueColumnId = computed(
    () => this.sheet().columns[0]?.id ?? 'value',
  );
  protected readonly sourceColumnId = computed(
    () => this.sheet().columns[1]?.id ?? 'source',
  );
  protected readonly valueColumnLabel = computed(
    () => this.sheet().columns[0]?.label ?? '',
  );

  protected resolveValueCell(row: PefRow): PefCell {
    const template = row.cellTemplate ?? {};
    const override = row.cells?.[this.valueColumnId()] ?? {};
    const merged = { ...template, ...override } as PefCell;
    if (!merged.type) return { type: 'empty' };
    if (
      (merged.type === 'input' || merged.type === 'calculated') &&
      !merged.valueKey
    ) {
      merged.valueKey = `${this.sheet().id}.${row.id}.${this.valueColumnId()}`;
    }
    return merged;
  }
  protected resolveSourceCell(row: PefRow): PefCell {
    const template = row.cellTemplate ?? {};
    const override = row.cells?.[this.sourceColumnId()] ?? {};

    const merged = { ...template, ...override } as PefCell;
    if (!merged.type) return { type: 'empty' };
    console.log(merged);
    if (
      (merged.type === 'input' || merged.type === 'calculated') &&
      !merged.valueKey
    ) {
      merged.valueKey = `${this.sheet().id}.${row.id}.${this.sourceColumnId()}`;
    }

    return merged;
  }

  protected cellValue(row: PefRow): number | string | null {
    const cell = this.resolveValueCell(row);
    const key =
      cell.valueKey ?? `${this.sheet().id}.${row.id}.${this.valueColumnId()}`;
    return this.data()[key] ?? null;
  }

  protected cellSourceValue(row: PefRow): number | string | null {
    const cell = this.resolveSourceCell(row);
    const key =
      cell.valueKey ?? `${this.sheet().id}.${row.id}.${this.sourceColumnId()}`;
    const value = this.data()[key] ?? null;

    console.log(value, cell.valueKey, key);
    return value;
  }

  protected isCellDirty(row: PefRow): boolean {
    const cell = this.resolveValueCell(row);
    const key =
      cell.valueKey ?? `${this.sheet().id}.${row.id}.${this.valueColumnId()}`;
    return this.dirtyKeys().has(key);
  }
}
